import { createContext, useContext, useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { campaignQuery, nextCampaignQuery } from "@/utils/googleRegistrationAttribution";

const CampaignContext = createContext<string | null>(null);

/** Request-scoped on SSR, memory-only in the browser: no tracking storage. */
export function CampaignProvider({ children }: { children: ReactNode }) {
  const { search } = useLocation();
  const [state, setState] = useState(() => ({ search, campaign: campaignQuery(search) }));
  const campaign = state.search === search
    ? state.campaign
    : nextCampaignQuery(state.campaign, search);
  if (state.search !== search) setState({ search, campaign });
  return <CampaignContext.Provider value={campaign}>{children}</CampaignContext.Provider>;
}

/** The fallback supports isolated CTA rendering without the app provider. */
export function useCampaignQuery(): string {
  const campaign = useContext(CampaignContext);
  const { search } = useLocation();
  return campaign ?? campaignQuery(search);
}
